import {EntityDecoratorOptions} from './entity.interface';
export function entityDecorator (options: EntityDecoratorOptions) {
  return (target: Function) => {
    if (options.url[options.url.length - 1] === '/') {
      const url: any = options.url.split('');
      url.pop();
      options.url = url.join('');
    }
    options.idName = options.idName || 'id';
    options.name = options.name || options.url.split('/').pop();
    options.root = options.root || options.name;
    Object.assign(target.prototype, options);
  };
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity.decorator.ts